<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form :inline="true" class="inline-form">
          <el-form-item label="使用时间">
            <el-date-picker
              v-model="useTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="流水号">
            <el-input class="search-input" v-model="busTransId" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="资金变动方式">
            <el-select style="width: 120px;" v-model="changeType">
              <el-option label="流入" value="0"></el-option>
              <el-option label="流出" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 合计 -->
      <el-col>
        <el-form :inline="true">
          <el-form-item label="活动金余额：">{{ totalAmountCount.ActivityBalance }}元</el-form-item>
          <el-form-item label="累计充值：">{{ totalAmountCount.TotalRecharge }}元</el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 活动金变动列表table -->
      <el-table
        stripe
        style="width:100%;"
        :data="eventMoneyChangeList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + 1"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="fCreateTime"
          label="变动时间"
          align="center"
          min-width="230">
        </el-table-column>
        <el-table-column
          prop="fAgentBatchId"
          label="流水号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fPreAmount"
          label="初期余额(元)"
          align="center"
          min-width="250"
          v-if="showMoneyChange">
          <template slot-scope="scope">
            <div>{{ scope.row.fPreAmount | formatAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fAmount"
          label="本次发生余额(元)"
          align="center"
          min-width="250">
          <template slot-scope="scope">
            <div>{{ scope.row.fAmount | formatAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fLastAmount"
          label="末期余额(元)"
          align="center"
          min-width="250"
          v-if="showMoneyChange">
          <template slot-scope="scope">
            <div>{{ scope.row.fLastAmount | formatAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fChangeTypeStr"
          label="资金变动方式"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="250">
          <template slot-scope="scope">
            <auth-button
              opt="details"
              type="text"
              v-if="scope.row.fChangeTypeStr === '流出'"
              label="明细"
              @click.native="handleDetail(scope.$index, scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <!-- 活动金查看dialog -->
    <el-dialog
      :visible.sync="changeDetailDialogVisible"
      width="80%">
      <div style="display: inline-block;width: 100%;" v-loading="changeDetailDialogLoading">
        <div>
          <el-col>
            <el-form :inline="true" class="inline-form">
              <el-form-item label="补贴时间">
                <el-date-picker
                  v-model="detailUseTime"
                  type="daterange"
                  align="left"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="商户流水号">
                <el-input class="search-input" v-model="detailOrderId" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label="商户编号">
                <el-input class="search-input" v-model="detailMerchantId" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="detailsearchClick">查询</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </div>
        <div>
          <el-table
            border
            show-summary
            :summary-method="getSummaries"
            style="width:100%;"
            :data="eventMoneyList"
            max-height="490">
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + 1"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="fCreateTime"
              label="补贴时间"
              align="center"
              min-width="180">
            </el-table-column>

            <el-table-column
              prop="fAgentBatchId"
              label="流水号"
              align="center"
              min-width="180">
            </el-table-column>
            <el-table-column
              prop="fOrderId"
              label="商户流水号"
              align="center"
              min-width="180">
            </el-table-column>

            <el-table-column
              prop="fMerchantId"
              label="商户编号"
              align="center"
              min-width="180">
            </el-table-column>
            <el-table-column
              prop="fMerchantName"
              label="商户名称"
              align="center"
              min-width="150">
            </el-table-column>
            <el-table-column
              prop="fSettleAmount"
              label="原结算金额(元)"
              align="center"
              min-width="150">
              <template slot-scope="scope">
                <div>{{ scope.row.fSettleAmount | formatAmount }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="fServiceFee"
              label="手续费补贴金额(元)"
              align="center"
              min-width="150">
              <template slot-scope="scope">
                <div>{{ scope.row.fServiceFee | formatAmount }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="fMarketingFee"
              label="营销补贴金额(元)"
              align="center"
              min-width="150">
              <template slot-scope="scope">
                <div>{{ scope.row.fMarketingFee | formatAmount }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="fTotalSettleAmount"
              label="最终结算金额金额(元)"
              align="center"
              min-width="150">
              <template slot-scope="scope">
                <div>{{ scope.row.fTotalSettleAmount | formatAmount }}</div>
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" class="btm-action">
            <el-pagination
              v-if="detailPaginations.count > 0"
              class="pagination"
              :page-size="detailPaginations.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="detailPaginations.count"
              :current-page="detailPaginations.pageNo"
              @current-change="onDetailChangeCurrentPage">
            </el-pagination>
          </el-col>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { subsidyMoneyChange, subsidyMoneyDeductDetail } from '@/api/activity'

export default {
  name: 'ChangeList',
  components: {},
  data () {
    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        FStartTime: '',
        FEndTime: '',
        FBusTransId: '',
        FChangeType: '0'
      },
      useTime: '',
      busTransId: '',
      changeType: '0',
      totalAmountCount: {},
      eventMoneyChangeList: [],
      detailEventMoneyInfo: '',
      changeDetailDialogVisible: false,
      changeDetailDialogLoading: false,
      showMoneyChange: false,
      // 明细分页组件传的信息
      detailPaginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 明细搜索表单信息
      detailSearchInfo: {
        FStartTime: '',
        FEndTime: '',
        FOrderId: '',
        FMerchantId: ''
      },
      detailUseTime: '',
      detailOrderId: '',
      detailMerchantId: '',
      eventMoneyList: []
    }
  },
  mounted () {
    this.searchClick()
  },
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * 合计计算方法
     */
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.label === '手续费补贴金额(元)' || column.label === '营销补贴金额(元)' || column.label === '原结算金额(元)' || column.label === '最终结算金额金额(元)') {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          } else {
            sums[index] = 'N/A'
          }
        }
      })
      sums.forEach((element, index) => {
        if (element && !isNaN(element)) {
          sums[index] = parseFloat(element / 100).toFixed(2)
        }
      })
      return sums
    },
    /**
     * 筛选查询按钮点击
     */
    searchClick (noReset) {
      this.searchInfo.FStartTime = this.useTime && this.useTime[0] ? this.useTime[0] : ''
      this.searchInfo.FEndTime = this.useTime && this.useTime[1] ? this.useTime[1] : ''
      this.searchInfo.FBusTransId = this.busTransId || ''
      this.searchInfo.FChangeType = this.changeType || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      this.searchInfo = Object.assign(this.searchInfo, this.paginations)
      this.listAgentSubsidyMoneyChangeFn()
    },
    /**
     * 删除提交参数中的空字段
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 记录明细按钮点击
     */
    handleDetail (index, row, scope) {
      console.log(`index: ${index}, row: `, row)
      this.detailEventMoneyInfo = row
      this.detailUseTime = ''
      this.detailOrderId = ''
      this.detailMerchantId = ''
      this.detailsearchClick()
      this.changeDetailDialogVisible = true
    },
    /**
     * 明细列表改变当前页事件
     * @param  {number} page 当前页码
     */
    onDetailChangeCurrentPage (page) {
      this.detailPaginations.pageNo = page
      this.detailsearchClick(true)
    },
    /**
     * 明细列表筛选查询按钮点击
     */
    detailsearchClick (noReset) {
      console.log('明细查询点击')
      this.detailSearchInfo.FAgentBatchId = this.detailEventMoneyInfo.fAgentBatchId || ''
      this.detailSearchInfo.FStartTime = this.detailUseTime && this.detailUseTime[0] ? this.detailUseTime[0] : ''
      this.detailSearchInfo.FEndTime = this.detailUseTime && this.detailUseTime[1] ? this.detailUseTime[1] : ''
      this.detailSearchInfo.FOrderId = this.detailOrderId || ''
      this.detailSearchInfo.FMerchantId = this.detailMerchantId || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.detailPaginations.pageNo = 1
        this.detailPaginations.count = 0
      }
      this.detailSearchInfo = Object.assign(this.detailSearchInfo, this.detailPaginations)
      this.listAgentSubsidyMoneyDeductDetail()
    },
    /**
     * 活动金变动列表
     */
    listAgentSubsidyMoneyChangeFn () {
      // this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      subsidyMoneyChange(params).then(response => {
        this.loading = false
        console.log('listAgentSubsidyMoneyChange response:', response)
        if (response.error_code === '0') {
          this.eventMoneyChangeList = response.data.list
          this.paginations.count = response.data.totalCount
          this.totalAmountCount.ActivityBalance = response.data.ActivityBalance
          this.totalAmountCount.TotalRecharge = response.data.TotalRecharge
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 活动金变动列表 详情
     */
    listAgentSubsidyMoneyDeductDetail () {
      this.changeDetailDialogLoading = true
      const params = qs.stringify(this.detailSearchInfo)
      console.log(params)
      subsidyMoneyDeductDetail(params).then(response => {
        this.changeDetailDialogLoading = false
        console.log('listAgentSubsidyMoneyDeductDetail response:', response)
        if (response.error_code === '0') {
          this.eventMoneyList = response.data.list
          this.detailPaginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  },
  computed: {},
  filters: {
    formatAmount (value) {
      return (!value && parseInt(value) !== 0) ? '--' : parseFloat(parseFloat(value).toFixed(2) / 100).toFixed(2)
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
</style>
